import BgVideo from "../components/BgVideo";
import Footer from "../components/Footer";
import img1 from './../assets/img1.png';
import img2 from './../assets/img2.png';
import img3 from './../assets/img3.png';
import img4 from './../assets/img4.png';
import img5 from './../assets/img5.png';
import img6 from './../assets/img6.png';
import img7 from './../assets/img7.png';
import img8 from './../assets/img8.png';
type Props = {}

function HowItWorks({ }: Props) {
    return (
        <div className="relative flex flex-col items-center bg-black">

            {/*Hero*/}
            <div className='relative w-screen h-screen mb-10'>
                <BgVideo />
            </div>

            {/*Main*/}
            <div className="w-9/12">
                <div className="flex flex-col xl:flex-row mt-40 xl:mt-44 gap-8 items-center">
                    <img src={img1} className="xl:h-[150px]"/>
                    <div className="flex flex-col">
                        <span className="flex md:justify-center xl:justify-end font-bold text-[35px] xl:text-[45px] text-center xl:text-left text-neonGreen">EVENT TRACKING</span>
                        <span className="flex justify-end text-center xl:text-end font-regular text-[20px] xl:text-[25px] text-white">Track every interaction [assets] of a sponsored activation and get real-time results.</span>
                    </div>
                </div>

                <div className="flex flex-col xl:flex-row mt-28 gap-8 items-center">
                    <div className="flex flex-col">
                        <span className="font-bold text-[35px] xl:text-[45px] text-center xl:text-left text-neonGreen">DATA VISUALIZATION</span>
                        <span className="font-regular text-[20px] xl:text-[25px] text-white text-center xl:text-start">Visualize your event data in easy-to-understand charts and graphs, revealing key trends and patterns.</span>
                    </div>
                    <img src={img2} className="xl:h-[198px]"/>
                </div>

                <div className="flex flex-col xl:flex-row mt-28 gap-8 items-center">
                    <img src={img3} className="xl:h-[220px]"/>
                    <div className="flex flex-col">
                        <span className="flex md:justify-center xl:justify-end font-bold text-center text-[35px] xl:text-[45px] text-neonGreen">REAL-TIME ANALYTICS</span>
                        <span className="flex justify-end xl:text-end text-center font-regular text-[20px] xl:text-[25px] text-white">Access real-time data to make informed decisions during your event.</span>
                    </div>
                </div>

                <div className="flex flex-col xl:flex-row mt-28 gap-8 items-center">
                    <div className="flex flex-col">
                        <span className="font-bold text-[35px] xl:text-[45px] text-center xl:text-left text-neonGreen">AI-POWERED INSIGHTS</span>
                        <span className="font-regular text-[20px] xl:text-[25px] text-white text-center xl:text-start">Leverage AI to uncover hidden insights and predict future trends.</span>
                    </div>
                    <img src={img4} className="xl:h-[150px]"/>
                </div>

                <div className="flex flex-col xl:flex-row mt-28 gap-8 items-center">
                    <img src={img5} className="xl:h-[220px]"/>
                    <div className="flex flex-col">
                        <span className="flex justify-center xl:justify-end font-bold text-[35px] xl:text-[45px] text-neonGreen">BENCHMARKING</span>
                        <span className="flex justify-end text-center xl:text-end font-regular text-[20px] xl:text-[25px] text-white">Compare your event performance against industry benchmarks and previous events.</span>
                    </div>
                </div>

                <div className="flex flex-col xl:flex-row mt-28 gap-8 items-center">
                    <div className="flex flex-col">
                        <span className="font-bold text-[35px] xl:text-[45px] text-center xl:text-left text-neonGreen">ROI MEASUREMENT</span>
                        <span className="font-regular text-[20px] xl:text-[25px] text-center xl:text-start text-white">Calculate the return on investment for your events and identify areas for improvement.</span>
                    </div>
                    <img src={img6} className="xl:h-[150px]"/>
                </div>

                <div className="flex flex-col xl:flex-row mt-28 gap-8 items-center">
                    <img src={img7} className="xl:h-[180px]"/>
                    <div className="flex flex-col">
                        <span className="flex justify-end text-center xl:text-end font-bold text-[35px] xl:text-[45px] text-neonGreen">TARGET AUDIENCE SEGMENTATION</span>
                        <span className="flex justify-end text-center xl:text-end font-regular text-[20px] xl:text-[25px] text-white">Track Target Audience reach and compare optimize future performance.</span>
                    </div>
                </div>

                <div className="flex flex-col xl:flex-row my-28 gap-8 items-center">
                    <div className="flex flex-col">
                        <span className="font-bold text-[35px] xl:text-[45px] text-center xl:text-left text-neonGreen">REAL-TIME FEEDBACK</span>
                        <span className="font-regular text-[20px] xl:text-[25px] text-center xl:text-start text-white">Collect feedback and learnings to improve future activations or asset performance.</span>
                    </div>
                    <img src={img8} className="xl:h-[200px]"/>
                </div>
            </div>

            {/*Footer*/}
            <div className='w-11/12 my-7'>
                <Footer />
            </div>
        </div>
    )
}

export default HowItWorks